import React, { useState, useEffect, useContext } from 'react';
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table';
import { Col, Container, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { GlobalContext } from '../../context/provider';
import numberbeautifuly from '../../../utils/numberbeautify';
import expensereportaction from '../../context/action/report/expensereportaction';
import Expense_report_list from './expense_report_list';

const Expense_report = () => {
    const { reportState, reportDispatch } = useContext(GlobalContext);
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    const [name, setname] = useState('');
    const [location, setlocation] = useState('');
    const [extype, setextype] = useState('');
    const [from, setfrom] = useState();
    const [to, setto] = useState();
    const [show, setshow] = useState(false);
    const [show1, setshow1] = useState(false);
    const [show2, setshow2] = useState(false);
    return (
        <div dir="rtl">
            <Container className='print_hide'>
                <Row className='mt-3'>
                    <Col lg={2} className="mt-3">
                        <Form.Group controlId="formBasicName">
                            <Form.Label>ناوی کەس</Form.Label>
                            <Form.Control type="text" placeholder="ناوی کەس" value={name} onChange={(val) => setname(val.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col lg={2} className="mt-3">
                        <Form.Group controlId="formBasicName">
                            <Form.Label>شوێن</Form.Label>
                            <Form.Control type="text" placeholder="شوێن" value={location} onChange={(val) => setlocation(val.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col lg={2} className="mt-3">
                        <Form.Group controlId="formBasicName">
                            <Form.Label>جۆری خەرجی</Form.Label>
                            <Form.Control type="text" placeholder="جۆری خەرجی" value={extype} onChange={(val) => setextype(val.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col lg={2} className="mt-3">
                        <Form.Group controlId="formBasicName">
                            <Form.Label>لە بەرواری</Form.Label>
                            <Form.Control type="date" placeholder="لە بەرواری" value={from} onChange={(val) => setfrom(val.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col lg={2} className="mt-3">
                        <Form.Group controlId="formBasicName">
                            <Form.Label>بۆ بەرواری</Form.Label>
                            <Form.Control type="date" placeholder="بۆ بەرواری" value={to} onChange={(val) => setto(val.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col lg={1} className="mt-5"
                        onClick={() => {
                            expensereportaction(name, location, extype, from, to)(reportDispatch);
                        }}
                    >
                        <Button >گەڕان</Button>
                    </Col>
                </Row>
                <Expense_report_list />
            </Container>
        </div>
    )
}

export default Expense_report